import { Component, EventEmitter, Input, Output } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-basic-input',
  templateUrl: './basic-input.component.html',
})
export class BasicInputComponent {
  @Input() disabled = false;

  @Input() label: string;

  @Input() value: string;

  @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();

  uuid: string;

  constructor() {
    this.uuid = uuidv4();
  }
}
